import type * as Money from 'ezmoney';

import { type CurrenciesKey } from 'src/core/config/money';

import { type Attachment } from './attachment';
import { type Counterparty } from './counterparty';

export type BaseBill = {
  id: string;
  amount: Money.MonetaryValue<CurrenciesKey>;
  // Optional net amount (without taxes) experimental field behind feature flag TMP_ANALYTICAL_SPLITS
  netAmount?: Money.MonetaryValue<CurrenciesKey>;
  counterparty: Counterparty;
  requestId: string;
  internationalTransferRequirements?: Record<string, unknown>;
};

export type InvoiceBill = BaseBill & {
  type: 'invoice';
  dueDate: string;
  documentaryEvidence: {
    invoiceNumber: string;
    attachments?: Attachment[];
  };
  spendingCommitment: {
    issueDate: string;
    description: string;
  };
};

export type ExpenseBill = BaseBill & {
  type: 'expense';
  spendingCommitment: {
    description: string;
  };
};

export type Bill = InvoiceBill | ExpenseBill;

export const isInvoiceBill = (bill: Bill): bill is InvoiceBill =>
  bill.type === 'invoice';
